/**
 * @author: subhasish.ghosh@zoom.us
 */

import {
  AppBar,
  Box,
  Button,
  IconButton,
  Skeleton,
  Toolbar,
  Typography,
} from "@mui/material";
import { Divider } from "@zoom/react-ui";
import UserAvatar from "./UserAvatar";
import React from "react";
import { ZOOM_LOGO } from "@utils/constants";

const NAV_ITEMS = Object.freeze([
  // {
  //   tab: "Aging",
  //   uri: "/aging",
  // },
]);

const Appbar = ({
  userName,
  isUserInfoLoading,
  setUserInfoModalOpen,
  appName,
}) => (
  <Box className="appbar_container">
    <AppBar
      className="dashboard-title-bar"
      position="fixed"
      sx={{ zIndex: 1202, height: "58px", background: "#ffff" }}
    >
      <Toolbar>
        <img
          src={ZOOM_LOGO}
          alt="Zoom Logo"
          className="nav-logo"
          onClick={() => (window.location = "/")}
        />
        <Divider orientation="vertical" className="nav-separator" />
        <Typography
          variant="h6"
          noWrap
          component="div"
          style={{ color: "#0C66E4", fontWeight: "bold", marginLeft: "1rem" }}
          className="operations-3d-title"
        >
          {appName}
        </Typography>
        <Box
          sx={{
            display: { xs: "none", sm: "block" },
            margin: "10px 20px",
            paddingTop: "4px",
          }}
          className="nav_item_container"
        >
          {NAV_ITEMS.map((item, _i) => (
            <Button
              onClick={() => (window.location = item.uri)}
              key={`nav_key_${_i}`}
              sx={{
                color: "#2f4f4f",
                fontWeight: "bold",
                alignItems: "center",
              }}
            >
              {item.tab}
            </Button>
          ))}
        </Box>
        <Box sx={{ ml: "auto" }}></Box>
        {!isUserInfoLoading ? (
          <IconButton
            onClick={() => setUserInfoModalOpen((old) => !old)}
            style={{ textTransform: "none" }}
          >
            <UserAvatar name={userName || "Guest"} />
          </IconButton>
        ) : (
          <Skeleton
            animation="wave"
            width={400}
            style={{ padding: "5px", margin: "0 15px 0 0" }}
          />
        )}
      </Toolbar>
    </AppBar>
  </Box>
);

export default Appbar;
